import { $Qll, $Q } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import { setSidebarMenuPosition } from '../utils/menu';
import { setOverflow } from '../utils/set-overflow';

/**
 * add event listener to each arrow button in menu items
 */
function btnSubMenu() {
  $Qll('header .site-nav__item').forEach((item) => {
    const closestNavItem = item;
    const header = $Q('.header');

    if (!item || !header) return;

    item.addEventListener('mouseenter', () => showItemSubMenu(closestNavItem));
    header.addEventListener('mouseleave', () =>
      removeMenuActives(closestNavItem)
    );
  });

  $Qll('.sidebar-menu .site-nav__item').forEach((item) => {
    item.addEventListener('click', () => showItemSubMenu(item));
  });
}

/**
 *
 * @param {DOM element} item to toggle data-active
 * it will remove data-active from all other items and set data-active to item received
 */
function showItemSubMenu(item) {
  if (!item) return;
  removeMenuActives(item);
  dataToggle(item);
}

function removeMenuActives(item) {
  const navItems = $Qll('.site-nav__item');

  if (!navItems) return;

  navItems.forEach((navItem) => {
    if (item !== navItem) navItem.setAttribute('data-active', 'false');
  });
}

function onClickButtonMenu() {
  const sidebarMenu = $Q('.sidebar-menu');
  const menuButton = $Q('.menu-button');

  if (!menuButton) return;

  const header = $Q('.jc-header');

  menuButton.addEventListener('click', () => {
    dataToggle(sidebarMenu);
    dataToggle(menuButton);

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(header.getBoundingClientRect().bottom)}px`
    );

    const isActive = JSON.parse(sidebarMenu.dataset.active);
    if (isActive) {
      window.dataLayer.push({
        event: 'menu_open',
      });
      setOverflow('hidden', 'body');
    } else {
      setOverflow('auto', 'body');
    }
  });
}

/**
 * add event listener to close button in sidebar menu
 * it will close sidebar menu
 * CURRENTLY NOT IN USE
 */
function onClickCloseMenu() {
  const closeButton = $Q('.sidebar-menu__close');
  const sidebarMenu = $Q('.sidebar-menu');
  const menuButton = $Q('.menu-button');
  const shadowClose = $Q('.sidebar-menu-shadow');

  if (shadowClose) {
    shadowClose.addEventListener('click', () => {
      menuButton.click();
    });
  }

  if (!closeButton || !sidebarMenu) return;

  closeButton.addEventListener('click', () => {
    dataToggle(sidebarMenu);
  });
}

function onClickLink() {
  const links = $Qll('.js-header a');

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();

        window.dataLayer.push({
          event: window.innerWidth < 768 ? 'menu_click_mob' : 'menu_click_dsk',
          elementURL: link.href,
          elementText: link.innerText,
        });

        if (link.href != '#') {
          window.location.href = link.href;
        }

    });
  });
}

setSidebarMenuPosition();
btnSubMenu();
onClickButtonMenu();
onClickCloseMenu();
onClickLink();
